export default {"src":"/_next/static/media/repair-color.eaa389fb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};